var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Group } from '@/models/Group';
import { Project } from '@/models/Project';
import Templates from '@/views/Projects/Tabs/ProjectPlan/Templates';
import AlertCard from '@/components/alert-card/AlertCard';
let ProjectPlan = class ProjectPlan extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isLoading = false;
        this.groupProject = null;
        // #endregion
        // #region Class methods
        // #endregion
        // #region Async methods
        // #endregion
        // #region Getters & Setters
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    async mounted() {
        if (this.group.type && typeof this.group.type !== 'string' && this.group.type.label === 'parnassys') {
            this.$router.go(-1);
            return;
        }
        if (this.group && this.group.projects && this.group.projects.length > 0) {
            this.groupProject = await new Project().include(['templates']).find(this.group.projects[0]);
        }
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], ProjectPlan.prototype, "group", void 0);
ProjectPlan = __decorate([
    Component({
        components: {
            Templates,
            AlertCard,
        },
    })
], ProjectPlan);
export default ProjectPlan;
